"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2681],{

/***/ 56861:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
}), 'AddAPhoto');

exports.Z = _default;

/***/ }),

/***/ 42065:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.62 2.99c-.49-.49-1.28-.49-1.77 0L6.54 11.3c-.39.39-.39 1.02 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77L9.38 12l7.25-7.25c.48-.48.48-1.28-.01-1.76z"
}), 'ArrowBackIosRounded');

exports.Z = _default;

/***/ }),

/***/ 50594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 63441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"
}), 'Download');

exports.Z = _default;

/***/ }),

/***/ 68346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(93680);
// EXTERNAL MODULE: ./node_modules/@mui/base/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(93427);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js + 1 modules
var capitalize = __webpack_require__(81582);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(78884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useIsFocusVisible.js + 1 modules
var useIsFocusVisible = __webpack_require__(2151);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useForkRef.js + 1 modules
var useForkRef = __webpack_require__(71315);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js + 1 modules
var generateUtilityClass = __webpack_require__(64371);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Link/linkClasses.js


function getLinkUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiLink', slot);
}
const linkClasses = (0,generateUtilityClasses/* default */.Z)('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
/* harmony default export */ var Link_linkClasses = (linkClasses);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Link/getTextDecoration.js

const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};

const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};

const getTextDecoration = ({
  theme,
  ownerState
}) => {
  const transformedColor = transformDeprecatedColors(ownerState.color);
  const color = (0,style/* getPath */.D)(theme, `palette.${transformedColor}`, false) || ownerState.color;
  const channelColor = (0,style/* getPath */.D)(theme, `palette.${transformedColor}Channel`);

  if ('vars' in theme && channelColor) {
    return `rgba(${channelColor} / 0.4)`;
  }

  return (0,colorManipulator/* alpha */.Fq)(color, 0.4);
};

/* harmony default export */ var Link_getTextDecoration = (getTextDecoration);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Link/Link.js


const _excluded = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"];















const useUtilityClasses = ownerState => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ['root', `underline${(0,capitalize/* default */.Z)(underline)}`, component === 'button' && 'button', focusVisible && 'focusVisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getLinkUtilityClass, classes);
};

const LinkRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiLink',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`underline${(0,capitalize/* default */.Z)(ownerState.underline)}`], ownerState.component === 'button' && styles.button];
  }
})(({
  theme,
  ownerState
}) => {
  return (0,esm_extends/* default */.Z)({}, ownerState.underline === 'none' && {
    textDecoration: 'none'
  }, ownerState.underline === 'hover' && {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }, ownerState.underline === 'always' && (0,esm_extends/* default */.Z)({
    textDecoration: 'underline'
  }, ownerState.color !== 'inherit' && {
    textDecorationColor: Link_getTextDecoration({
      theme,
      ownerState
    })
  }, {
    '&:hover': {
      textDecorationColor: 'inherit'
    }
  }), ownerState.component === 'button' && {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    [`&.${Link_linkClasses.focusVisible}`]: {
      outline: 'auto'
    }
  });
});
const Link = /*#__PURE__*/react.forwardRef(function Link(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiLink'
  });

  const {
    className,
    color = 'primary',
    component = 'a',
    onBlur,
    onFocus,
    TypographyClasses,
    underline = 'always',
    variant = 'inherit',
    sx
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  const [focusVisible, setFocusVisible] = react.useState(false);
  const handlerRef = (0,useForkRef/* default */.Z)(ref, focusVisibleRef);

  const handleBlur = event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  const handleFocus = event => {
    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    focusVisible,
    underline,
    variant
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRoot, (0,esm_extends/* default */.Z)({
    color: color,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    classes: TypographyClasses,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    ownerState: ownerState,
    variant: variant,
    sx: [...(!Object.keys(colorTransformations).includes(color) ? [{
      color
    }] : []), ...(Array.isArray(sx) ? sx : [sx])]
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Link_Link = (Link);

/***/ }),

/***/ 98449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ContentContainer; }
/* harmony export */ });
/* unused harmony export ContentContainerFunction */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13264);
/*
 * File: ContentContainer.tsx
 * Project: meki
 * File Created: Wednesday, 28th October 2020 3:47:54 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Friday, 24th November 2023 5:17:04 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2020 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


var ContentDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "desktopHeight" && prop !== "bottomNavigation" && prop !== "background" && prop !== "marginTopStyle" && prop !== "hasBorder";
    }
})(function(param) {
    var bottomNavigation = param.bottomNavigation, _background = param.background, background = _background === void 0 ? "white" : _background, _marginTopStyle = param.marginTopStyle, marginTopStyle = _marginTopStyle === void 0 ? 0 : _marginTopStyle, _hasBorder = param.hasBorder, hasBorder = _hasBorder === void 0 ? true : _hasBorder, _desktopHeight = param.desktopHeight, desktopHeight = _desktopHeight === void 0 ? null : _desktopHeight;
    return {
        paddingBottom: bottomNavigation ? 52 : "",
        marginTop: marginTopStyle,
        paddingTop: 0,
        overflowY: "hidden",
        position: "relative",
        background: background,
        borderRadius: hasBorder ? 12 : 0,
        "&::-webkit-scrollbar": {
            display: "none"
        },
        msOverflowStyle: "none" /* IE and Edge */ ,
        scrollbarWidth: "none" /* Firefox */ ,
        height: desktopHeight ? desktopHeight : "calc(90dvh)",
        "@media (max-width: 900px)": {
            minHeight: "100dvh",
            height: "unset",
            overflowY: "hidden"
        }
    };
});
function ContentContainerFunction(props, ref) {
    /**
   * Custom Meki container that includes top padding for the
   * Meki Header
   *
   * @param BottomActionTabProps - left and right react components.
   * @returns React Component
   *
   * @beta
   */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentDiv, {
        desktopHeight: props.desktopHeight,
        bottomNavigation: props.bottomNavigation,
        marginTopStyle: props.marginTopStyle,
        background: props.background,
        className: props.className,
        id: props.id,
        ref: ref,
        hasBorder: props.hasBorder,
        children: props.children
    });
}
var ContentContainer = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ContentContainerFunction);


/***/ }),

/***/ 37989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lw": function() { return /* binding */ ButtonDiv; },
/* harmony export */   "yU": function() { return /* binding */ TypographyButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47842);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);



var ButtonDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "fixed",
    bottom: "0",
    width: "100%",
    height: "80px",
    backgroundColor: "white",
    borderTop: "1px solid #EAEAEA",
    zIndex: 2,
    "@media (min-width: 900px)": {
        position: "sticky"
    }
});
var Button = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button", {
    shouldForwardProp: function(prop) {
        return prop !== "disabled";
    }
})(function(param) {
    var disabled = param.disabled, theme = param.theme;
    var _obj;
    return _obj = {
        backgroundColor: disabled ? "#EAEAEA" : "#0A7ABE",
        borderRadius: "100px",
        padding: "8px 60px",
        cursor: disabled ? "default" : "pointer",
        border: "none",
        transition: "all 0.3s ease-in-out",
        color: "white",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 8
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(330), {
        padding: "8px 40px"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(275), {
        padding: "8px 20px"
    }), _obj;
});
var TypographyButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontFamily: "Poppins",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(400), {
        fontSize: "14px"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(275), {
        fontSize: "12px"
    }), _obj;
});



/***/ }),

/***/ 90400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ModalButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37989);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70754);




function ModalButton(props) {
    var handleNext = props.handleNext, text = props.text, form = props.form, type = props.type, alternative = props.alternative, alternativeText = props.alternativeText, disabled = props.disabled, children = props.children, loading = props.loading;
    var handleClick = function(event) {
        if (disabled) {
            event.preventDefault();
            return;
        }
        handleNext();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .ButtonDiv */ .Lw, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                    onClick: handleClick,
                    form: form,
                    type: type,
                    alternative: Boolean(alternative),
                    disabled: disabled,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .TypographyButton */ .yU, {
                            children: alternative ? alternativeText : text
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20,
                            color: "inherit"
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 84726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ModalContent; }
});

// UNUSED EXPORTS: ModalContentFunction

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/components/ModalContent.styles.ts


var ContentDiv = (0,styled/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "mobileHeight" && prop !== "desktopHeight" && prop !== "isSafari" && prop !== "removePadding";
    }
})(function(param) {
    var removePadding = param.removePadding, desktopHeight = param.desktopHeight, mobileHeight = param.mobileHeight, isSafari = param.isSafari, theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        padding: removePadding ? 0 : "16px 12px",
        overflow: "scroll",
        backgroundColor: "#F9F9F9",
        flexDirection: "column",
        height: mobileHeight ? mobileHeight : "calc(100dvh - 64px)",
        "@media (min-width: 900px)": {
            height: desktopHeight ? desktopHeight : "calc(90dvh - 150px)",
            paddingBottom: "10px"
        }
    }, theme.breakpoints.down(900), {
        paddingBottom: isSafari ? "180px" : "100px"
    });
});


;// CONCATENATED MODULE: ./src/components/ModalContent.tsx



function ModalContentFunction(props, ref) {
    var children = props.children, _removePadding = props.removePadding, removePadding = _removePadding === void 0 ? false : _removePadding, _desktopHeight = props.desktopHeight, desktopHeight = _desktopHeight === void 0 ? null : _desktopHeight, _mobileHeight = props.mobileHeight, mobileHeight = _mobileHeight === void 0 ? null : _mobileHeight, _isSafari = props.isSafari, isSafari = _isSafari === void 0 ? false : _isSafari;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentDiv, {
        removePadding: removePadding,
        desktopHeight: desktopHeight,
        mobileHeight: mobileHeight,
        isSafari: isSafari,
        ref: ref,
        children: children
    });
}
var ModalContent = /*#__PURE__*/ (0,react.forwardRef)(ModalContentFunction);


/***/ }),

/***/ 69051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47842);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80562);
/* harmony import */ var _hooks_useModalRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9006);
/* harmony import */ var _mui_icons_material_ArrowBackIosRounded__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42065);
/* harmony import */ var _screens_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83372);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29630);
/* harmony import */ var _screens_cart_DrawerCart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24950);
/*
 * File: ModalHeader.tsx
 * Project: meki
 * File Created: Wednesday, 8th February 2023 11:45:16 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Wednesday, 8th February 2023 11:45:27 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 









var HeaderDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "hideBorder";
    }
})(function(param) {
    var hideBorder = param.hideBorder;
    return {
        height: "64px",
        backgroundColor: "#FFFFFF",
        color: "#414046",
        top: 0,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        borderBottom: "1px solid #EAEAEA",
        boxShadow: hideBorder ? "" : "0px 1px 10px rgba(0, 0, 0, 0.12)",
        position: "sticky",
        zIndex: 4000
    };
});
var BackTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    visibility: "hidden",
    color: "#414046",
    "@media (min-width: 900px)": {
        visibility: "visible"
    }
});
var DrawerMenuDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("div")({
    marginLeft: 20
});
var TitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "19px",
    lineHeight: "28.5px",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center"
});
var LeftDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("div")({
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    left: 0
});
var RightDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "absolute",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        right: 20
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(380), {
        right: 5
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(330), {
        right: 0
    }), _obj;
});
function Header(props) {
    var title = props.title, menuIcon = props.menuIcon, backIcon = props.backIcon, backText = props.backText, backFunction = props.backFunction, hideBorder = props.hideBorder, cartIcon = props.cartIcon;
    var routerModal = (0,_hooks_useModalRouter__WEBPACK_IMPORTED_MODULE_2__/* .useModalRouter */ .r)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderDiv, {
        hideBorder: hideBorder,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LeftDiv, {
                children: [
                    menuIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DrawerMenuDiv, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_menu__WEBPACK_IMPORTED_MODULE_3__/* .DrawerMenu */ .O, {
                            menuIconColorChange: true
                        })
                    }),
                    backIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        onClick: backFunction ? backFunction : routerModal.back,
                        color: "inherit",
                        "aria-label": "back",
                        size: "large",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowBackIosRounded__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                    }),
                    backText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackTypography, {
                        onClick: routerModal.back,
                        children: "Atr\xe1s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleTypography, {
                children: title
            }),
            " ",
            cartIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightDiv, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_cart_DrawerCart__WEBPACK_IMPORTED_MODULE_4__/* .DrawerCart */ .$, {
                    barChange: true
                })
            })
        ]
    });
}


/***/ }),

/***/ 54098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Prescriptions": function() { return /* binding */ Prescriptions; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/queries/order/queries/currentOrderWithPrescriptions.ts
var currentOrderWithPrescriptions = __webpack_require__(3073);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./src/components/ModalHeader.tsx
var ModalHeader = __webpack_require__(69051);
// EXTERNAL MODULE: ./src/components/ModalButton.tsx
var ModalButton = __webpack_require__(90400);
// EXTERNAL MODULE: ./src/components/ModalContent.tsx + 1 modules
var ModalContent = __webpack_require__(84726);
// EXTERNAL MODULE: ./src/hooks/useModalRouter.ts
var useModalRouter = __webpack_require__(9006);
// EXTERNAL MODULE: ./src/screens/prescription/components/UploadImage.tsx + 2 modules
var UploadImage = __webpack_require__(55823);
// EXTERNAL MODULE: ./src/screens/prescription/styles/Info.styles.ts
var Info_styles = __webpack_require__(63325);
;// CONCATENATED MODULE: ./src/screens/prescription/components/Info.tsx


function Info() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info_styles/* RootDiv */.of, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_styles/* TitleTypography */.dP, {
                children: "\xbfQu\xe9 haremos con tu receta?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_styles/* DivisionLine */.O3, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info_styles/* InfoContainerDiv */.jo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info_styles/* InfoContainerItem */.zC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_styles/* InfoContainerItemImg */.Lt, {
                                src: "/assets/images/prescription1.png",
                                alt: "persona"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_styles/* InfoContainerItemText */.AU, {
                                children: "Al terminar la compra tu receta ser\xe1 revisada por nuestros qu\xedmicos farmac\xe9uticos."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info_styles/* InfoContainerItem */.zC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_styles/* InfoContainerItemImg */.Lt, {
                                src: "/assets/images/prescription2.png",
                                alt: "receta"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_styles/* InfoContainerItemText */.AU, {
                                children: "De ser necesario retiraremos el documento original al momento del despacho."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info_styles/* InfoContainerItem */.zC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_styles/* InfoContainerItemImg */.Lt, {
                                src: "/assets/images/prescription3.png",
                                alt: "cashback"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_styles/* InfoContainerItemText */.AU, {
                                children: "En caso de que la receta sea rechazada, te contactaremos para el reembolso del producto."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(98449);
// EXTERNAL MODULE: ./src/screens/product/utils/extractExtraInfo.tsx
var extractExtraInfo = __webpack_require__(73724);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/prescription/styles/ItemDetails.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    maxWidth: "200px",
    minWidth: "100px",
    paddingBottom: 0,
    padding: "0 10px 0px 12px",
    "@media (min-width: 450px)": {
        flex: 1,
        maxWidth: "90%"
    }
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    maxWidth: "200px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#414046",
    "@media (min-width: 450px)": {
        maxWidth: "90%"
    }
});
var DetailsTextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#757475",
    span: {
        color: "#414046"
    }
});
var DetailsPriceDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    marginTop: "1px"
});
var DetailsPriceTypographyBold = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var DetailsPriceTypographyLight = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});


;// CONCATENATED MODULE: ./src/screens/prescription/components/ItemDetails.tsx





var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
    fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
});
function CartProductDetails(props) {
    var product = props.product, price = props.price, quantity = props.quantity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                variant: "subtitle2",
                children: product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                children: (0,extractExtraInfo/* extractExtraInfo */.UD)(product)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                children: product.laboratory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPriceTypographyBold, {
                        children: quantity > 1 && "".concat(currFormat.format(price * quantity), "・")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceTypographyLight, {
                        children: [
                            "".concat(currFormat.format(price)),
                            "/un"
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./src/screens/prescription/styles/Item.styles.ts


var Item_styles_RootDiv = (0,styled/* default */.Z)("div")({
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    padding: "12px",
    borderBottom: "1px solid #EAEAEA",
    alignItems: "center",
    height: "104.5px",
    position: "relative",
    ":last-child": {
        borderRadius: "0 0 10px 10px",
        borderBottom: "none"
    }
});
var ProductQuantity = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "0 20px"
});
var VerticalLine = (0,styled/* default */.Z)("hr")({
    height: "104.5px",
    margin: 0,
    border: "1px solid #EAEAEA",
    position: "absolute",
    marginLeft: "60px"
});
var ImgDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    width: "80px",
    justifyContent: "center",
    marginLeft: "30px",
    height: "inherit",
    alignItems: "center"
});
var ImgProduct = (0,styled/* default */.Z)("img")({
    width: "100%",
    display: "block",
    objectFit: "contain",
    maxHeight: "80%"
});
var SkeletonQuantity = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "20px",
    height: "20px",
    marginLeft: "10px",
    marginRight: "50px"
});
var SkeletonImg = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "5rem",
    height: "5rem"
});
var SkeletonText = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "130px",
    height: "80px",
    marginLeft: "16px"
});


;// CONCATENATED MODULE: ./src/screens/prescription/components/Item.tsx




function Item(props) {
    var product = props.product, price = props.price, quantity = props.quantity;
    var loading = false;
    var ref = (0,react.useState)(product.imagesUrl[0]), imageUrl = ref[0], setImageUrl = ref[1];
    var handleImageError = function() {
        setImageUrl("/assets/images/default.webp");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item_styles_RootDiv, {
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonQuantity, {
                variant: "rectangular"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductQuantity, {
                children: quantity
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonImg, {
                variant: "rectangular"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgProduct, {
                    src: imageUrl,
                    onError: handleImageError
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLine, {}),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText, {
                variant: "rectangular"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductDetails, {
                product: product,
                price: price,
                quantity: quantity
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/prescription/styles/ItemsList.styles.ts


var ItemsList_styles_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var isDelivery = param.isDelivery;
    return {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        border: "1px solid #EAEAEA",
        borderRadius: "10px",
        margin: isDelivery ? "17px 0px 0 0" : "17px 0px 97px 0"
    };
});
var ItemsList_styles_TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#414046",
    marginBottom: "12px",
    textAlign: "left",
    marginLeft: "12px",
    marginTop: "12px"
});
var SubTitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#414046",
    marginBottom: "12px",
    textAlign: "left",
    marginLeft: "12px",
    marginTop: "12px"
});
var DivisionLine = (0,styled/* default */.Z)("div")({
    height: "1px",
    backgroundColor: "#EAEAEA"
});


;// CONCATENATED MODULE: ./src/screens/prescription/components/ItemsList.tsx





var prescriptionName = {
    NOT_REQUIRED: "Receta simple",
    HELD: "Receta retenida",
    SIMPLE: "Receta simple",
    CHECK: "Receta cheque"
};
function ItemsList(props) {
    var productsByPrescription = props.productsByPrescription;
    utils/* Console.log */.Mn.log("productsByPrescription", productsByPrescription);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList_styles_RootDiv, {
        isDelivery: true,
        children: productsByPrescription === null || productsByPrescription === void 0 ? void 0 : productsByPrescription.map(function(item, index) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleTypography, {
                        children: prescriptionName[item === null || item === void 0 ? void 0 : item[0]]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DivisionLine, {}),
                    item === null || item === void 0 ? void 0 : (ref = item[1]) === null || ref === void 0 ? void 0 : ref.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            product: product,
                            price: product.price,
                            quantity: +product.quantity
                        }, index);
                    })
                ]
            }, index);
        })
    });
}

// EXTERNAL MODULE: ./src/components/Loader.tsx
var Loader = __webpack_require__(76931);
// EXTERNAL MODULE: ./src/hooks/usePendingPrescriptions.ts + 1 modules
var usePendingPrescriptions = __webpack_require__(3618);
;// CONCATENATED MODULE: ./src/screens/prescription/index.tsx
























function Prescriptions(param) {
    var redirectOnNonePending = param.redirectOnNonePending;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(true), loadingUser = ref4[0], setLoadingUser = ref4[1];
    var ref5 = (0,react.useState)(false), emtpyError = ref5[0], setError = ref5[1];
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var router = (0,useModalRouter/* useModalRouter */.r)();
    var _query = router.query, code = _query.codigo;
    var codeString = code ? decodeURI(code) : "";
    var appUser = (0,useAuth/* useAuth */.a)({
        forceAuth: true
    }).appUser;
    var track = (0,useSegment/* useSegment */.K)().track;
    var ref6 = (0,useQuery/* useQuery */.a)((0,currentOrderWithPrescriptions/* currentOrderWithPrescriptions */.l)(), {
        returnPartialData: true,
        fetchPolicy: "cache-and-network",
        skip: !appUser
    }), data = ref6.data, loading = ref6.loading, error = ref6.error;
    var ref7 = (0,usePendingPrescriptions/* usePendingPrescriptions */.h)(), requirePrescriptions = ref7.requirePrescriptions, requirePrescriptionUpload = ref7.requirePrescriptionUpload, prescriptionLoading = ref7.loading, associatedPrescriptions = ref7.associatedPrescriptions;
    var products = (0,react.useMemo)(function() {
        var ref;
        return data === null || data === void 0 ? void 0 : (ref = data.currentOrder) === null || ref === void 0 ? void 0 : ref.orderDetails.filter(function(detail) {
            return detail.product.prescriptionType && detail.product.prescriptionType !== "NOT_REQUIRED";
        }).map(function(detail) {
            return detail.product;
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.currentOrder) === null || ref === void 0 ? void 0 : ref.orderDetails
    ]);
    var productsByPrescriptionType = (0,react.useMemo)(function() {
        var ref;
        if (!isLocalVendor) return null;
        return data === null || data === void 0 ? void 0 : (ref = data.currentOrder) === null || ref === void 0 ? void 0 : ref.orderDetails.reduce(function(acc, detail) {
            var ref;
            var prescriptionType = detail === null || detail === void 0 ? void 0 : (ref = detail.product) === null || ref === void 0 ? void 0 : ref.prescriptionType;
            if (prescriptionType) {
                var typeKey = prescriptionType == "NOT_REQUIRED" ? "SIMPLE" : prescriptionType;
                if (acc[typeKey]) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, typeKey, (0,_to_consumable_array/* default */.Z)(acc[typeKey]).concat([
                        (0,_object_spread/* default */.Z)({
                            price: detail.price,
                            quantity: detail.quantity
                        }, detail.product), 
                    ])));
                }
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, typeKey, [
                    (0,_object_spread/* default */.Z)({
                        price: detail.price,
                        quantity: detail.quantity
                    }, detail.product), 
                ]));
            }
            return acc;
        }, {});
    }, [
        data === null || data === void 0 ? void 0 : (ref1 = data.currentOrder) === null || ref1 === void 0 ? void 0 : ref1.orderDetails,
        isLocalVendor
    ]);
    var prescriptionsUploaded = (0,react.useMemo)(function() {
        var ref;
        return (data === null || data === void 0 ? void 0 : (ref = data.pendingPrescriptions) === null || ref === void 0 ? void 0 : ref.length) > 0;
    }, [
        data === null || data === void 0 ? void 0 : (ref2 = data.pendingPrescriptions) === null || ref2 === void 0 ? void 0 : ref2.length
    ]);
    var handleNext = function() {
        var ref, ref1;
        if (isLocalVendor) {
            void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentMethodLocal"));
        }
        if (!products) {
            void track("prescription press next without products", {
                products: products
            });
            return;
        }
        if (!prescriptionsUploaded && requirePrescriptionUpload && associatedPrescriptions.length === 0) {
            utils/* Console.log */.Mn.log("No prescriptions uploaded");
            setError(true);
            return;
        }
        void track("confirm_prescriptions", {
            uploaded_prescription_amount: data === null || data === void 0 ? void 0 : (ref = data.pendingPrescriptions) === null || ref === void 0 ? void 0 : ref.length
        });
        var ref2;
        void track("prescription upload", {
            uploaded_prescription_amount: data === null || data === void 0 ? void 0 : (ref1 = data.pendingPrescriptions) === null || ref1 === void 0 ? void 0 : ref1.length,
            products_amount: products === null || products === void 0 ? void 0 : products.length,
            prescription_types: Array.from((ref2 = new Set(products.map(function(e) {
                return e.prescriptionType;
            }))) !== null && ref2 !== void 0 ? ref2 : [])
        });
        void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentConfirm"));
    };
    (0,react.useEffect)(function() {
        if (appUser) {
            setLoadingUser(false);
        }
    }, [
        appUser
    ]);
    (0,react.useEffect)(function handleNoPrescriptionNeeded() {
        var ref, ref1;
        if (appUser && !loading && (!(data === null || data === void 0 ? void 0 : data.currentOrder) || (data === null || data === void 0 ? void 0 : (ref = data.currentOrder) === null || ref === void 0 ? void 0 : (ref1 = ref.orderDetails) === null || ref1 === void 0 ? void 0 : ref1.length) === 0) && redirectOnNonePending) {
            void router.replace((0,utils/* getRoute */.Bv)("cart"));
            return;
        }
        if (prescriptionLoading || loading || error || !products) return;
        var ref2;
        void track("prescription request", {
            products_amount: products.length,
            prescription_types: Array.from((ref2 = new Set(products.map(function(e) {
                return e.prescriptionType;
            }))) !== null && ref2 !== void 0 ? ref2 : []),
            userId: appUser === null || appUser === void 0 ? void 0 : appUser.id,
            productIds: products.map(function(e) {
                return e.id;
            })
        });
        var ref3;
        void track("prescription upload", {
            uploaded_prescription_amount: data === null || data === void 0 ? void 0 : data.pendingPrescriptions.length,
            products_amount: products.length,
            prescription_types: Array.from((ref3 = new Set(products.map(function(e) {
                return e.prescriptionType;
            }))) !== null && ref3 !== void 0 ? ref3 : [])
        });
        if (!loading && !prescriptionLoading && !requirePrescriptions && redirectOnNonePending) {
            setTimeout(function() {
                void router.replace((0,utils/* getRoute */.Bv)("checkout", code ? {
                    codigo: codeString
                } : {}));
            }, 300);
        }
    }, [
        error,
        loading,
        router,
        track,
        products,
        data === null || data === void 0 ? void 0 : (ref3 = data.pendingPrescriptions) === null || ref3 === void 0 ? void 0 : ref3.length,
        data === null || data === void 0 ? void 0 : data.currentOrder,
        appUser,
        redirectOnNonePending,
        code,
        codeString,
        prescriptionLoading,
        requirePrescriptions, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* ContentContainer */.E, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader/* Header */.h, {
                    title: isLocalVendor ? "Pedir receta" : "Subir receta",
                    backIcon: true,
                    backFunction: function() {
                        void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentMethod"));
                    }
                }),
                isLocalVendor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent/* ModalContent */.h, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList, {
                        productsByPrescription: Object.entries(productsByPrescriptionType !== null && productsByPrescriptionType !== void 0 ? productsByPrescriptionType : {}).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), type = _param[0], products = _param[1];
                            return [
                                type,
                                products
                            ];
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent/* ModalContent */.h, {
                    children: loadingUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            data && /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* UploadImage */.z, {
                                emptyError: emtpyError,
                                setError: setError,
                                data: data
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButton/* ModalButton */.m, {
                    handleNext: handleNext,
                    text: "Siguiente"
                })
            ]
        })
    });
}


/***/ }),

/***/ 63325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ InfoContainerItemText; },
/* harmony export */   "Lt": function() { return /* binding */ InfoContainerItemImg; },
/* harmony export */   "O3": function() { return /* binding */ DivisionLine; },
/* harmony export */   "dP": function() { return /* binding */ TitleTypography; },
/* harmony export */   "jo": function() { return /* binding */ InfoContainerDiv; },
/* harmony export */   "of": function() { return /* binding */ RootDiv; },
/* harmony export */   "zC": function() { return /* binding */ InfoContainerItem; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81719);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);


var RootDiv = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")({
    border: "1px solid #EAEAEA",
    backgroundColor: "white",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "12px 15px",
    borderRadius: "10px",
    marginTop: "20px"
});
var TitleTypography = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#333333",
    marginBottom: "12px",
    textAlign: "left"
});
var DivisionLine = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")({
    height: "1px",
    backgroundColor: "#EAEAEA",
    marginBottom: "12px",
    width: "calc(100% + 30px)",
    marginLeft: "-15px"
});
var InfoContainerDiv = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%"
});
var InfoContainerItem = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    marginBottom: "12px",
    marginLeft: "5px"
});
var InfoContainerItemImg = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("img")({
    width: "21px",
    display: "block",
    marginRight: "15px"
});
var InfoContainerItemText = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#757475"
});



/***/ })

}]);